module.exports = __webpack_public_path__ + "img/Brave.6e0fd26c.png";